import GraphQLClient from 'ts/GraphQLClient'
import { RepoParams } from 'ts/types'
import {
  ActualsNewApiResponse,
  CreditsApiResponse,
  GetActualsNewResponse,
  GetCreditsParams,
  GetCreditsResponse
} from 'ts/types/actuals'
import { GET_ACTUALS, GET_CREDITS } from './graphql'

interface ActualsRepoParams {
  year: number
  token: string
}

export default class ActualsRepo {
  private client: GraphQLClient

  constructor({ GRAPHQL_URL, GRAPHQL_API_KEY }: RepoParams) {
    this.client = new GraphQLClient({ url: GRAPHQL_URL, apiKey: GRAPHQL_API_KEY })
  }

  async getActuals(params: ActualsRepoParams): Promise<GetActualsNewResponse> {
    const { year, token } = params

    const response = await this.client.request<ActualsNewApiResponse>({
      query: GET_ACTUALS,
      variables: {
        token,
        year
      }
    })

    return response.getUsageDetailsForUserNew
  }

  async getCredits(params: GetCreditsParams): Promise<GetCreditsResponse> {
    const { token, year, month } = params

    const response = await this.client.request<CreditsApiResponse>({
      query: GET_CREDITS,
      variables: {
        token,
        year,
        month
      }
    })

    return response.getCredits
  }
}
